import React, { Component } from "react";
// import { getClinicListApi } from "../../api/clinicService";
import Button from "../../utils/Buttons";
import { withRouter } from "../../utils/withRouter";
class StaffForm extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     formData: {
  //       fullName: "",
  //       email: "",
  //       clinics: "",
  //       gender: "MALE",
  //       mobileCountryCode: "+91",
  //     },
  //     clinicList: [],
  //     loadingClinics: true,
  //     error: null,
  //   };
  // }
  // componentDidMount() {
  //   const userId = this.props.location?.state?.userId;
  //   console.log("User ID in StaffForm:", userId);
  //   this.loadClinics(userId);
  //   if (this.props.initialData) {
  //     this.fillForm(this.props.initialData);
  //   }
  // }
  componentDidUpdate(prevProps) {
    if (
      this.props.initialData &&
      prevProps.initialData !== this.props.initialData
    ) {
      this.fillForm(this.props.initialData);
    }
  }
  // fillForm = (data) => {
  //   this.setState((prevState) => ({
  //     formData: {
  //       ...prevState.formData,
  //       ...data,
  //       clinics: data?.clinics?._id || data?.clinics || "",
  //     },
  //   }));
  // };
  // loadClinics = async (userId) => {
  //   try {
  //     const res = await getClinicListApi(userId);
  //     let clinics = res?.data;
  //     if (!Array.isArray(clinics)) {
  //       clinics = clinics ? [clinics] : [];
  //     }
  //     this.setState({
  //       clinicList: clinics,
  //       loadingClinics: false,
  //     });
  //   } catch (error) {
  //     this.setState({
  //       loadingClinics: false,
  //       error: "Failed to load clinics",
  //     });
  //   }
  // };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.formData);
  };
  render() {
    const { loading, initialData } = this.props;
    const { formData, clinicList } = this.state;
    const isEdit = !!initialData;
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="card p-3">
          <h5>{isEdit ? "Edit Staff" : "Add Staff"}</h5>
          <div className="row">
            <div className="mb-3 col-md-6">
              <label>
                Full Name<span className="error">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                className="form-control"
                value={formData.fullName}
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="mb-3 col-md-6">
              <label>
                Email<span className="error">*</span>
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={this.handleChange}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-3 col-md-4">
              <label>
                Mobile Country Code<span className="error">*</span>
              </label>
              <input
                type="text"
                name="mobileCountryCode"
                className="form-control"
                value={formData.mobileCountryCode}
                onChange={this.handleChange}
              />
            </div>
            <div className="mb-3 col-md-4">
              <label>
                Clinic<span className="error">*</span>
              </label>
              <select
                name="clinics"
                className="form-control"
                value={formData.clinics}
                onChange={this.handleChange}
                required
              >
                <option value="">Select Clinic</option>
                {clinicList.map((clinic) => (
                  <option key={clinic._id} value={clinic._id}>
                    {clinic._id}
                  </option>
                ))}
              </select>
            </div>
            {!isEdit && (
              <div className="mb-3 col-md-4">
                <label>
                  Role<span className="error">*</span>
                </label>
                <select
                  name="role"
                  className="form-control"
                  value={formData.role}
                  onChange={this.handleChange}
                >
                  <option value="STAFF">STAFF</option>
                  <option value="ADMIN">ADMIN</option>
                </select>
              </div>
            )}
            <div className="mb-3 col-md-4">
              <label>
                Gender<span className="error">*</span>
              </label>
              <select
                name="gender"
                className="form-control"
                value={formData.gender}
                onChange={this.handleChange}
              >
                <option value="MALE">MALE</option>
                <option value="FEMALE">FEMALE</option>
              </select>
            </div>
            {isEdit && (
              <div className="mb-3 col-md-4">
                <label>Status</label>
                <select
                  name="status"
                  className="form-control"
                  value={formData.status}
                  onChange={this.handleChange}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>
            )}
          </div>
          <div className="d-flex justify-content-end">
            <Button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              text={loading ? "Saving..." : "Submit"}
            />
          </div>
        </div>
      </form>
    );
  }
}
export default withRouter(StaffForm);
